import { render, staticRenderFns } from "./view-subscriber.vue?vue&type=template&id=bdf27140&scoped=true&"
import script from "./view-subscriber.vue?vue&type=script&lang=js&"
export * from "./view-subscriber.vue?vue&type=script&lang=js&"
import style0 from "./view-subscriber.vue?vue&type=style&index=0&id=bdf27140&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf27140",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VDivider,VForm,VRow,VSimpleTable})
